<template>
      <div class="column col-10 col-mx-auto">
     
                    
        <div class="wrap">
            
            <h3  class="entry-title"> <i class="fas fa-check"></i> {{ message}} </h3>                    


        </div>
        
    </div>

</template>
<script>

  export default{
    name: 'AuthologicReturn',



     data(){

            return {

              message: 'Trwa weryfikacja..',
             
              waitCount: 0
              
            }
       },




       methods: {




        gotomain(){

            this.$router.push({path: '/'});
        },




        onWaiting( endpoint='application' ) {


          var page = this.$root.mainpage,
              step,


            poll = () => {

              if (this.waitCount > 60){

                page.isLoading =false;
                return;
              }

              this.waitCount++;


              this.get( '/' + endpoint )
                  .then(response => {



                    if (!!response.data) {

                      step = response.data.hasOwnProperty('step') ? response.data.step : '';

    //console.log(step);

                      switch (step) {

                        case 'counteroffer':
                        case 'wait':
                          break;

                                                          
                        default:
                          page.isLoading =false;

                          this.message = 'Dziękujemy za weryfikację. Twoj wniosek oczekuje na decyzję o której powiadomimy Cię wiadomością SMS.';
                        //  this.$router.push({path: 'thankyou'});
                          return;
                      }


    //console.log(response.data)

                   
                    }
                    else {
                      console.log('status empty body');
                    }


                    // dispatch another poll request
                    page.isLoading
                      && setTimeout(poll, 3000);                



                  })
                  .catch(error => {
                   
                      // wait for timeout
                      //page.isLoading = false;
                      setTimeout(poll, 3000);

         
                      // Error 
                      if (error.response) {
                     

                      } else if (error.request) {
                        
                      } else {
                          // Something happened in setting up the request and triggered an Error
                          //console.log('Error', error.message);
                      }
                  });


            };


            // initial polling
            setTimeout(poll, 3000);
        }

    },





    created(){


      var page = this.$root.mainpage;


            this.waitCount = 0;


      this.post('/authologic')
              .then(response => {


                if (!!response.data) {

                  let ok = !(response.data.IS_ERROR | 0);


                  if (ok) {


                    //page.isLoading = 'to może potrwać do 2 minut..,prosimy o cierpliwość..';
                    //this.onWaiting();

                    this.message = 'Dziękujemy za weryfikację. Twoj wniosek oczekuje na decyzję o której powiadomimy Cię wiadomością SMS.';

                  }



                }
              })
              .catch(error => {

                  // Error
                  if (error.response) {

                    page.isLoading = false;


                    this.message = error.response.data.Message == 'No active session' ?  'Dziękujemy za weryfikację. Twoj wniosek oczekuje na decyzję o której powiadomimy Cię wiadomością SMS.' : 'Wystąpił problem z weryfikacją Twojego wniosku, niebawem się skontakujemy.';



                     console.log(error.response);
                  }
              });


      }
     
    
    }

</script>
<style scoped>


  h3 i {
    color: #0bc268;


  }


  .entry-title {


    font-size:32px;
    margin: 2.8em 0 2em;

    padding: 1rem 0 5rem;

    text-align: center;

  }


  .form-btn-wrap {

    margin-top: .5rem;
    padding: 2rem 1rem;

    display: flex;
    justify-content:center;
  }

  .button {

    cursor:pointer;
    min-width:260px;
    font-size: 16px;
    padding: 16px 40px;
    transition: ease-out 1s;
    line-height: 16px;

    border-radius:10px;
    border:0px;

    margin: 0 .5rem;

  }

  .button.btn-prev {

    background-color: #dfdfdf;
    color: rgb(64, 64, 64);
  }

  .button.btn-prev:hover {
    box-shadow: inset -400px 0 0 0 #bebebe;
  }



  .wrap {
    position:relative;
    padding-top:1rem;
    margin: 2rem 0;
  }

  .wrap::before {
    content: "";
    position: absolute;
    top: 0;
    left: -5em;
    right: 0;
    bottom: 0;
    display: block;
    background-color: #f7f7f7;
    border-radius: 0 90px 90px 0;
    -webkit-transform: skew(-17deg,0deg);
    transform: skew(-7deg,0deg);
    z-index: -2;
  }

  .wrap::after {
    content: "";
    position: absolute;
    top: 0;
    right: 50%;
    left: -100vw;
    bottom: 0;
    display: block;
    background-color: #f7f7f7;
    z-index: -2;
  }


  .fade-enter-active,.fade-leave-active {
    transition: opacity 3s
  }
  .fade-enter,.fade-leave-active {
    opacity: 0
  }


  .slide-fade-enter-active {
    transition: all .5s ease;
  }

  .slide-fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter,.slide-fade-leave-active {
    padding-left: 10px;
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/AuthologicReturn.vue